import React from "react";

import Icon from "./Icon";

/**
 * PLACEHOLDER de logo del cliente (texto visible = nombre del cliente).
 * El branding cosmético se afina TRAS las pruebas con el cliente.
 *
 * ▸ CUÁNDO Y CÓMO REEMPLAZAR (cuando llegue el arte):
 *   A) Logo en SVG (preferido):
 *      - Abrir el .svg, copiar su viewBox al atributo viewBox de abajo.
 *      - Reemplazar TODO el contenido entre <Icon> ... </Icon> por los
 *        <g>/<path> del SVG del logo.
 *   B) Logo en PNG:
 *      - Colocar el archivo en public/img/logo.png y, en App.js, cambiar
 *        <ClienteLoginIcon .../> por <img src="/img/logo.png" alt="SiderExpress" />.
 *   ▸ NO cambiar el nombre del componente ni el export (App.js los importa así).
 */
const ClienteLoginIcon = (props) => (
  <Icon
    viewBox="0 0 500 250"
    className={props.className}
    width={props.width}
    height={props.height}
  >
    <rect x="2" y="2" width="496" height="246" rx="16" fill="none" stroke="#C7CDD6" strokeWidth="2" strokeDasharray="8 8" />
    <text x="250" y="118" textAnchor="middle" fontFamily="Manrope, system-ui, sans-serif" fontSize="46" fontWeight="700" fill="#262A30">SiderExpress</text>
    <text x="250" y="160" textAnchor="middle" fontFamily="Manrope, system-ui, sans-serif" fontSize="16" fontWeight="500" fill="#7E819F">logo placeholder</text>
  </Icon>
);

export default ClienteLoginIcon;
